<template>
  <div class="counter-warp">
    <p>Vuex counter：
      {{ count }}
      </p>
    <p>
      <button @click="increment">+</button>
      <button @click="decrement">-</button>
    </p>

    <a @click="bindViewTap" class="home">去往首页</a>
  </div>
</template>

<script>

export default {
  data(){
    return{
        
    }
  },
  created(){
   // console.log(this.$store.state,999);
  },
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  methods: {
    bindViewTap(){
        this.$router.push('/');
    },
    increment () {
      this.$store.commit('increment')
    },
    decrement () {
      this.$store.commit('decrement')
    }
  }
}
</script>

<style scoped lang="less">
@import '../../assets/css/less.less';
.counter-warp {
  text-align: center;
  margin-top: 100/@r;
}
.home {
  display: inline-block;
  margin: 100/@r auto;
  padding: 5/@r 10/@r;
  color: blue;
  border: 1/@r solid blue;
}
</style>




// WEBPACK FOOTER //
// src/pages/counter/index.vue